import React from "react";
import { connect } from "react-redux";
import Loading from "../components/Loading";
import Button from "../components/buttons/Button";
import CallButton from "../components/buttons/CallButton";
import EditButton from "../components/buttons/EditButton";
import DeleteButton from "../components/buttons/DeleteButton";
import "./ContactInformation.css";

class ContactInformation extends React.Component {
  onSubmit = values => {
    this.props.saveContact({
      ...values,
      id: this.props.match.params.id,
    });
    this.props.history.push("/contacts");
  };

  render() {
    if (this.props.loading) {
      return <Loading />;
    }

    return (
      <div className="row">
        <div className="col-md-1 col-lg-3 col-xl-3"></div>
        <div className="col-md-10 col-lg-6 col-xl-6">
          <div className="d-flex justify-content-between">
            <h1 id="h1id" className="margin-auto">
              {this.props.contact.name}
            </h1>
          </div>
          <div className="d-flex justify-content-between information-content">
            <div className="content-item">
              <strong htmlFor="sipaddress">
                {this.props.text("common.sipaddress")}
              </strong>
              <div id="sipaddress">
                {this.props.contact.sipaddress !== null
                  ? this.props.contact.sipaddress
                  : "-"}
              </div>
            </div>
            <div className="content-item">
              <strong htmlFor="email">{this.props.text("common.email")}</strong>
              <div id="email">
                {this.props.contact.email !== null
                  ? this.props.contact.email
                  : "-"}
              </div>
            </div>
            <div className="content-item">
              <strong htmlFor="address">
                {this.props.text("common.address")}
              </strong>
              <div id="address">
                {this.props.contact.address !== null
                  ? this.props.contact.address
                  : "-"}
              </div>
            </div>
            <div className="content-item">
              <strong htmlFor="city">{this.props.text("common.city")}</strong>
              <div id="city">
                {this.props.contact.city !== null
                  ? this.props.contact.city
                  : "-"}
              </div>
            </div>
            <div className="content-item">
              <strong htmlFor="zipcode">
                {this.props.text("common.zipcode")}
              </strong>
              <div id="zipcode">
                {this.props.contact.postNr !== null
                  ? this.props.contact.postNr
                  : "-"}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between contact-information-buttons">
            <CallButton sipaddress={this.props.contact.sipaddress} />
            <EditButton
              to="/contacts/edit/"
              id={this.props.contact.id}
              text={this.props.text}
            />
            <DeleteButton
              to="/contacts/delete/"
              id={this.props.contact.id}
              text={this.props.text}
            />
            <Button
              className="contact-information-cancel"
              to={"/contacts"}
              text={this.props.text("common.cancel")}
            />
          </div>

          <div></div>
        </div>
        <div className="col-md-1 col-lg-3 col-xl-3"></div>
      </div>
    );
  }
}

function getContact(state, props) {
  if (!props.match.params.id) return {};
  var contact = {};
  state.contact.contacts.forEach(item => {
    if (item.id.toString() === props.match.params.id) {
      contact = item;
      contact.name = item.fname + " ";
      if (item.sname) {
        item.name = item.name + item.sname;
      }
    }
  });
  return contact;
}

const mapStateToProps = (state, props) => {
  return {
    contacts: state.contacts,
    contact: getContact(state, props),
    loading: state.contact.loading,
    text: state.config.text,
  };
};

export default connect(mapStateToProps)(ContactInformation);






// WEBPACK FOOTER //
// ./src/containers/ContactInformation.js